// extracted by mini-css-extract-plugin
export default {"loaderContainer":"COBarChart_loaderContainer__UgSKQ","labels":"COBarChart_labels__qh0Ox","xAxisLabel":"COBarChart_xAxisLabel__Rnvmg"};